let code = 'eplgestao';
let codeAPI = 'epl';
export const apiConstants = {
    code: `${code}`,
    codeAPI: `${codeAPI}`,
    // home: {
    //     acl: {
    //         view                    : 'EPL_00002',
    //     },
    // },
    // worktype: {
    //     acl: {
    //         view                    : 'EPL_00003',
    //         detail                  : 'EPL_00004',
    //         add                     : 'EPL_00007',
    //         edit                    : 'EPL_00005',
    //         delete                  : 'EPL_00006',
    //     },
    //     url: {
    //         getList                 : `/${codeAPI}/gestao/worktypes`,
    //         getShow                 : `/${codeAPI}/gestao/worktypes/:id`,
    //         getCreate               : `/${codeAPI}/gestao/worktypes`,
    //         getUpdate               : `/${codeAPI}/gestao/worktypes/:id`,
    //         getDelete               : `/${codeAPI}/gestao/worktypes/:id`,
    //         getGroups               : `/${codeAPI}/gestao/worktypes/groups`,
    //         getPlans                : `/${codeAPI}/gestao/plans/childs`,

    //         getConfig               : `/${codeAPI}/gestao/worktypes/settings`,
    //         getScales               : `/${codeAPI}/gestao/worktypes/scales`,
    //         getLayouts              : `/${codeAPI}/gestao/worktypes/print/layouts/worktype`,
    //         getFormats              : `/${codeAPI}/gestao/worktypes/print/formats/worktype`,
    //     },
    // },
    // map: {
    //     acl: {
    //         view                    : 'EPL_00008',
    //         detail                  : 'EPL_00009',
    //         add                     : 'EPL_00012',
    //         edit                    : 'EPL_00010',
    //         delete                  : 'EPL_00011',
    //     },
    //     url: {
    //         getList                 : `/${codeAPI}/gestao/plans`,
    //         getShow                 : `/${codeAPI}/gestao/plans/:id`,
    //         getCreate               : `/${codeAPI}/gestao/plans`,
    //         getUpdate               : `/${codeAPI}/gestao/plans/:id`,
    //         getDelete               : `/${codeAPI}/gestao/plans/:id`,
    //         getScales               : `/${codeAPI}/gestao/plans/scales`,
    //         getGroups               : `/${codeAPI}/gestao/plans/groups`,
    //         getResources            : `/backoffice/gestao/ogc/remoteservices/resources`,
    //     },
    // },
    // pmdfci: {
    //     acl: {
    //         view                    : 'EPL_00022',
    //         detail                  : 'EPL_00023',
    //         add                     : 'EPL_00026',
    //         edit                    : 'EPL_00024',
    //         delete                  : 'EPL_00025',
    //     },
    //     url: {
    //         getList                 : `/${codeAPI}/gestao/pmdfcis`,
    //         getShow                 : `/${codeAPI}/gestao/pmdfcis/:id`,
    //         getCreate               : `/${codeAPI}/gestao/pmdfcis`,
    //         getUpdate               : `/${codeAPI}/gestao/pmdfcis/:id`,
    //         getDelete               : `/${codeAPI}/gestao/pmdfcis/:id`,
    //         getConfig               : `/${codeAPI}/gestao/pmdfcis/settings`,
    //         getScales               : `/${codeAPI}/gestao/pmdfcis/scales`,
    //         getLayouts              : `/${codeAPI}/gestao/pmdfcis/print/layouts/pmdfci`,
    //         getFormats              : `/${codeAPI}/gestao/pmdfcis/print/formats/pmdfci`,
    //         getResources            : `/backoffice/gestao/ogc/remoteservices/resources`,
    //     },
    // },
    // pis: {
    //     acl: {
    //         view                    : 'EPL_00029',
    //         detail                  : 'EPL_00030',
    //         add                     : 'EPL_00033',
    //         edit                    : 'EPL_00031',
    //         delete                  : 'EPL_00032',
    //     },
    //     url: {
    //         getList                 : `/${codeAPI}/gestao/pis`,
    //         getShow                 : `/${codeAPI}/gestao/pis/:id`,
    //         getCreate               : `/${codeAPI}/gestao/pis`,
    //         getUpdate               : `/${codeAPI}/gestao/pis/:id`,
    //         getDelete               : `/${codeAPI}/gestao/pis/:id`,
    //         getConfig               : `/${codeAPI}/gestao/pis/settings`,
    //         getScales               : `/${codeAPI}/gestao/pis/scales`,
    //         getLayouts              : `/${codeAPI}/gestao/pis/print/layouts/pis`,
    //         getFormats              : `/${codeAPI}/gestao/pis/print/formats/pis`,
    //         getResources            : `/backoffice/gestao/ogc/remoteservices/resources`,
    //     },
    // },
    // layer: {
    //     acl: {
    //         view                    : 'EPL_00013',
    //         detail                  : 'EPL_00014',
    //         add                     : 'EPL_00017',
    //         edit                    : 'EPL_00015',
    //         delete                  : 'EPL_00016',
    //         private                 : 'EPL_00017',
    //     },
    //     url: {
    //         getGroups               : `${codeAPI}/gestao/layers/groups`,
    //         getList                 : `${codeAPI}/gestao/layers`,
    //         getShow                 : `${codeAPI}/gestao/layers/:id`,
    //         getCreate               : `${codeAPI}/gestao/layers`,
    //         getUpdate               : `${codeAPI}/gestao/layers/:id`,
    //         getDelete               : `${codeAPI}/gestao/layers/:id`,
    //         getOGCLists             : '/backoffice/gestao/ogc/lists',
    //     },
    // },
};